import BlogPostPreview from '../blog-post-preview/blog-post-preview.component';
import Post1 from '../../assets/images/img-blog-01.webp';
import Post2 from '../../assets/images/img-blog-02.webp';
import Post3 from '../../assets/images/img-blog-03.webp';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme, Box, Typography, Grid, Button } from '@mui/material';

const BlogPostsShowcase = () => {
  const posts = [
    {
      id: 1,
      imageUrl: Post1,
      title: 'Seguro viagem: descubra por que é essencial para a sua viagem',
      preview:
        'Se você está programando para fazer uma viagem internacional, confira como um seguro viagem vai...',
      postUrl:
        '/blog/seguro-viagem-descubra-por-que-e-essencial-para-sua-viagem',
    },
    {
      id: 2,
      imageUrl: Post2,
      title: 'Orlando: o melhor guia pelos parques temáticos',
      preview:
        'Orlando é uma cidade conhecida por seus parques temáticos e atrações turísticas. A cidade é...',
      postUrl:
        '/blog/orlando-o-melhor-guia-pelos-parques-tematicos',
    },
    {
      id: 3,
      imageUrl: Post3,
      title: 'Vai viajar para fora? Confira nosso checklist',
      preview:
        'Viajar para o exterior pode ser emocionante, mas também pode ser estressante se...',
      postUrl:
        '/blog/vai-viajar-para-fora-confira-nosso-checklist',
    },
  ];

  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          backgroundColor: `${theme.palette.grey[50]}`,
          borderRadius: `${theme.spacingValues.large}`,
          padding: `${theme.spacingValues.small} ${theme.spacingValues.medium}`,
          width: 'fit-content',
        }}
      >
        <Typography sx={{ color: `${theme.palette.primary.main}` }}>
          Blog
        </Typography>
      </Box>
      <Typography variant="h3" my={'1rem'}>
        Confira o{' '}
        <span style={{ color: theme.palette.primary.main }}>nosso Blog</span>
      </Typography>
      <Grid
        container
        spacing={2}
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
          gap: theme.spacingValues.medium,
          alignItems: 'stretch',
        }}
      >
        {posts.map((post) => (
          <Grid
            key={post.id}
            sx={{
              height: '100%',
              display: 'flex',
            }}
          >
            <BlogPostPreview post={post} sx={{ width: '100%' }} />
          </Grid>
        ))}
      </Grid>
      <Button
        component={RouterLink}
        to="/blog"
        variant="contained"
        size="large"
        sx={{ mt: 4 }}
      >
        Ver todos os posts
      </Button>
    </Box>
  );
};

export default BlogPostsShowcase;
